import { LitElement, html, css } from "lit";
import language from "#scripts/translation";

export class Hero extends LitElement {
  static properties = {
    type: { type: String },
  };

  static styles = css`
    :host {
      // display: none;
    }`;

  render () {
    return kariDialog;
  }
}

const kariDialog = () => {
  const kari = "";
  let extraKariLink = "";

  return html`
              <div class="chatbot__mobile__header">
                  <div class="row">
                      <div class="col-6">
                          <span class="chatbot__modal__header">
                          Kommune-Kari
                          </span>
                      </div>
                      <div class="col-6 text-right chatbot__modal__icons">
                          <button class="chatbot__modal__button chatbot__modal__option" id="chatbot__modal__option" aria-label="hjelp"><span class="material-icons-outlined notranslate">help_outline</span></button>
                          <button class="chatbot__modal__button chatbot__modal__close" id="chatbot__modal__close"aria-label="lukk"><span class="material-close-ui"></span></button>
                      </div>
                  </div>
              </div>
              
              <div class="chatbot__infopage">
                  <div class="container dialog__infopage__container">
                      <div class="row">
                          <div class="col-12 text-center">
                              <a href="#" class="dialog__actions__ddlink restart-chat">${language("DIALOG_RESTART")}</a>
                              <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                              <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                              <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">${language(
    "DIALOG_PRIVACY",
  )} <span class="material-icons-outlined notranslate">open_in_new</span></a>
                              ${extraKariLink}
                              
                              <button class="chatbot__infopage__close" id="chatbot__infopage__close">Tilbake</button>
                          </div>
                      </div>
                  </div>
              </div>
              
              <div class="chatbot-search chatbot-search--container" data-background="">
                  <!--div class="dialog__overlay__color"></div-->
                  <div class="dialog__overlay__graph-right"><img src="" alt=""/></div>
                  <!--div class="dialog__overlay__graph-left"></div-->
                  <div class="container dialog__messagearea__container" id="chatbot__messagearea">
                    <div class="row h-100">
                      <div class="col-lg-8 h-100">
                        <div class="dialog dialog__messagearea h-100">
                          <div class="dialog__scroller" id="dialog__scroller">
                            <div class="justify-content-lg-center jcm-tostart">
                              <div class="xcol-lg-10">
                                <div id="kari__dialog__window" class="dialog__container"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container dialog__inputarea__container">
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="dialog dialog__inputarea">
                          <div class="xrow justify-content-lg-center jcm-toend">
                            <div class="xcol-lg-10">
                              <div class="dialog__avatarcontainer dialog__avatarcontainer-input">${kari}</div>
                              <div class="dialog__inputcontainer">
                                <input type="text" 
                                    class="form-control dialog__input" 
                                    id="tilbakemelding" 
                                    maxlength="110"
                                    autocomplete="off" 
                                    aria-label="${language("DIALOG_FEEDBACK")}" 
                                    aria-describedby="chatinput__beskrivelse" 
                                    placeholder="${language("START_OR_SEARCH")}">
                                <label for="tilbakemelding" 
                                    class="d-none">${language("DIALOG_FEEDBACK")}</label>
                                <small id="chatinput__beskrivelse" 
                                    class="d-none text-muted">${language("DIALOG_MUTEINPUT")}</small>
                                <button type="button" class="dialog__sendbutton" aria-label="${language("DIALOG_SENDBTN")}">
                                    <span class="material-icons-outlined notranslate dialog__sendbutton__icon"></span>
                                </button>
                                <div id="chatinput__charCounter" class="dialog__input-counter"></div>
                              </div>
                              <div class="dialog__askarea">
                                <button type="button" class="dialog__askbutton" aria-label="${language("DIALOG_ASKME")}" role="button">Spør meg
                                  <span class="material-icons-outlined notranslate buttonrow__button__icon">arrow_forward</span>
                                </button>
                              </div>
                              <div class="dialog__actions__container">
                                <a href="#" class="dialog__actions__link restart-chat dialog__actions__link-hidden">
                                  ${language("DIALOG_RESTART")}
                                  <span class="material-icons-outlined notranslate">refresh</span>
                                </a>
                                <a href="#" class="dialog__actions__link dialog__actions__toggle">
                                  ${language("DIALOG_INFORMATION")}<span class="dialog__chevron__toggle material-icons-outlined material-chevron-bottom notranslate"></span>
                                </a>
                                <div class="dialog__actions">
                                    <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                                    <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                                    <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">
                                      ${language("DIALOG_PRIVACY")} 
                                      <span class="material-icons-outlined notranslate">open_in_new</span>
                                    </a>
                                    ${extraKariLink}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
          `;
}

customElements.define("aim-hero", Hero);
